<div class="modal-content">
    <!-- Cabeçalho do Modal com título e botão de fechar -->
    <div class="modal-header">
        <h5 class="modal-title">
            Adicionar Documento
        </h5>
        <button type="button" class="btn-close" aria-label="Fechar" (click)="activeModal.dismiss()"></button>
    </div>

    <div class="modal-body p-4">
        <h3 class="mb-3">{{ feiraCliente.nome }}</h3>
        <form [formGroup]="feiraClienteForm" (ngSubmit)="atualizarFeiraCliente()">
            <!-- Campo Nome -->
            <div class="mb-3 col-4">
                <label class="form-label">Metro quadrado</label>
                <input class="form-control" placeholder="Digite o metro quadrado" type="number" formControlName="metros"
                    [ngClass]="{
              'is-invalid':
              feiraClienteForm.controls.metros.errors &&
              feiraClienteForm.get('metros')?.touched,
            }" />
                <div class="invalid-feedback" *ngIf="feiraClienteForm.controls.metros.errors">
                    informe um metro quadrado
                </div>

            </div>


            <!-- Botão de Enviar -->
            <div class="text-end">
                <button type="submit" class="btn btn-success btn-sm w-md">
                    Atualizar
                </button>
            </div>
        </form>
    </div>
</div>